<template>
  <div v-if="networks.length > 0">
    <h4 class="mb-3">
      <strong>{{ title }}</strong>
    </h4>
    <slot name="heading"></slot>
    <slot v-if="!$auth.auth" name="not-logged-in"></slot>
    <p v-if="networks && networks.length == 0">
      <slot name="empty"></slot>
    </p>
    <div v-else class="row no-gutters">
      <!-- list all networks user is member of in a nice card format -->
      <div v-for="network in networks" :key="network.id" class="col-md-6 col-lg-4 col-sm-12 d-flex align-items-stretch">
        <NetworkCard :network="network" :notifications="notifications" />
      </div>
    </div>
  </div>
</template>
<script>
import NetworkCard from '@/components/commons/Networks/NetworkCard.vue';

export default {
  components: {
    NetworkCard,
  },
  props: {
    networks: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    notifications: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
